/**
 * 亚马逊订单列表
 * 重构版 - 使用拆分的模块
 */

import React from 'react';
import { Table, Card } from 'antd';
import { useOrderList, getOrderColumns, OrderFilters } from './OrderListModule';
import './OrderList.css';

const OrderList: React.FC = () => {
    const {
        loading,
        tableData,
        total,
        page,
        pageSize,
        searchText,
        statusFilter,
        channelFilter,
        dateRange,
        setPage,
        setPageSize,
        setSearchText,
        setStatusFilter,
        setChannelFilter,
        setDateRange,
        handleSearch,
        handleReset,
    } = useOrderList();

    const columns = getOrderColumns();

    return (
        <div style={{ padding: 24 }}>
            <Card title="亚马逊订单列表 (All Orders)" bordered={false} bodyStyle={{ padding: '0 24px 24px' }}>
                <OrderFilters
                    searchText={searchText}
                    statusFilter={statusFilter}
                    channelFilter={channelFilter}
                    dateRange={dateRange}
                    onSearchTextChange={setSearchText}
                    onStatusChange={setStatusFilter}
                    onChannelChange={setChannelFilter}
                    onDateRangeChange={setDateRange}
                    onSearch={handleSearch}
                    onReset={handleReset}
                />

                <Table
                    columns={columns}
                    dataSource={tableData}
                    rowKey={(record) => `${record.amazon_order_id}_${record.itemId || 'head'}`}
                    loading={loading}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: total,
                        onChange: (p, ps) => {
                            setPage(p);
                            setPageSize(ps);
                        },
                        showSizeChanger: true,
                        showTotal: (t) => `共 ${t} 条订单`
                    }}
                    scroll={{ x: 1500 }}
                    bordered
                    size="middle"
                />
            </Card>
        </div>
    );
};

export default OrderList;
